import React, {Component} from 'react';
import { withRouter } from "react-router";
import DrawerLink from '../../components/Drawer/DrawerLink';
import GroupItems from '../../components/Drawer/DrawerItems';
import {CanView} from '../../utils/checkRoles';

class SideBar extends Component{    
    render(){
        return(
            <>
                <DrawerLink link="/" icon="home" title="خانه" />
                <GroupItems icon="utensil-spoon" title="آشپزخانه" intrance="/foods" >
                    <DrawerLink link='/foods/program' icon="folder-open" title='برنامه غذایی' icoType="fad"/>
                    <DrawerLink link="/foods/" icon="utensils-alt" title='فهرست غذاها' icoType="fad"/>
                </GroupItems>
                <CanView role={2}>
                    <GroupItems icon="users" title="مدیریت کاربران" intrance="/users" >
                        <DrawerLink link="/users/" icon="user" title='فهرست کاربران' icoType="fad"/>
                    </GroupItems>
                </CanView>
                
                
            </>
        )
    }
}

export default withRouter(SideBar);
